import React from 'react';
import { ExampleDescription } from './ExampleDescription';
import { ExampleCodeSwitch } from './ExampleCodeSwitch';
import { getName } from '../../../../../utils/treeVisitors/helpers';

export const ExampleContent = ({
  example,
  data,
  prefix,
  isSingleExample,
  JSLayoutType,
}) => {
  const shouldRenderDescription = example.extra && example.extra.description;
  return (
    <React.Fragment>
      {shouldRenderDescription && (
        <ExampleDescription
          description={example.extra.description}
          prefix={prefix}
          pageName={getName(data)}
          isSingleExample={isSingleExample}
        />
      )}
      <ExampleCodeSwitch
        example={example}
        data={data}
        JSLayoutType={JSLayoutType}
      />
    </React.Fragment>
  );
};
